<template>
  <div class="brokerage_container">
    <!-- <div class="header">
      <div class="brokerage_title">佣金金额</div>
      <div class="brokerage_price">
        <div style="margin-bottom: 3vw;margin-right: 1vw;">¥</div>
        <div class="totalPrice">{{totalPrice}}</div>
      </div>
    </div> -->
    <div class="dec">
      <p class="paddingLeft">资金明细</p>
      <div class="wages">
        <span
          >收益 : <span class="fontWeight">{{ capital.income }}</span>
        </span>
        <span
          >退款 : <span class="fontWeight">{{ capital.outcome }}</span></span
        >
        <span
          >工资 : <span class="fontWeight">{{ capital.cashCome }}</span></span
        >
      </div>
    </div>
    <div class="noOrders" v-if="orderList.length == 0">
      <div v-if="!firstLoading">什么都没有哦...</div>
      <van-loading v-else type="spinner" />
    </div>
    <div v-if="orderList.length > 0" class="scroll">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="到底啦~"
        @load="onLoad"
        :immediate-check="false"
        v-if="orderList.length > 0"
      >
        <div class="main">
          <div
            class="list"
            id="list"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <div class="flex">
             <div>{{ item.logTime }}</div> 
              <div style="margin-left: 36px">{{ item.tag }}</div>
            </div>           
              <!-- <div class="list_l">{{ item.tag }}</div> -->
              <div class="fontBold" v-if="item.percentage >= 0">
                +{{ formatPrice(item.percentage) }}
              </div>
              <div class="fontBold" v-if="item.percentage < 0">
                {{ formatPrice(item.percentage) }}
              </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <!-- </van-pull-refresh> -->
  </div>
</template>
<script>
import {
  Toast,
  Dialog,
  List,
  PullRefresh,
  NavBar,
  Loading,
  Overlay
} from "vant";
import { mapGetters } from "vuex";
import service from "../../api/employeePage/index";
import loading from "../../components/loading/loading";
export default {
  name: "qecode",
  data() {
    return {
      isLoading: true, //loading状态
      orderList: [],
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      //   refreshing: false,
      firstLoading: true,
      capital: {}
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    loading
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.init();
  },
  methods: {
    formatPrice(price) {
      //   if (price >= 1) {
      return price.toFixed(2);
      //   } else {
      //     return price;
      //   }
    },
    onLoad() {
      this.page++;
      this.getList().then((list) => {
        this.orderList = this.orderList.concat(list.ownerBalanceRecordList);
        console.log(this.orderList, list, 105);
        this.loading = false;
        if (list.total <= this.orderList.length) {
          this.finished = true;
        }
      });
    },
    init() {
      // this.isLoading = true;
      this.page = 1;
      //   this.totalPrice = this.$route.query.price;
      this.firstLoading = true;
      this.loading = false;
      this.getList()
        .then((list) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 600);
          this.capital = list;
          // if (list.ownerBalanceRecordList.length !== 0) {
          this.orderList = list.ownerBalanceRecordList;
          this.finished = false;
          this.firstLoading = false;
          console.log(list.ownerBalanceRecordList, 126);
          if (list.total <= this.orderList.length) {
            this.finished = true;
            this.loading = false;
          }
          //  else {
          //   this.onLoad();
          // }
          // } else {
          //   this.list = [];
          //   this.loading = false;
          // }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getList() {
      return new Promise((resolve, reject) => {
        service
          .ownerBalance(this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.brokerage_container {
  position: fixed;
  overflow-y: scroll;
  // background: #fff;
  height: 100%;

  // height: calc(100% - 0.7vw);
  width: 100%;
  .van-nav-bar {
    background: #fd6a5f;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  @{deep} .van-nav-bar .van-icon {
    color: #fff;
  }
  @{deep} .van-nav-bar__title {
    color: #fff;
  }
  .fontWeight {
    margin-right: 6px;
  }
  .noOrders {
    width: 100%;
    text-align: center;
    font-size: 15px;
    color: #92909a;
    padding-top: 30vw;
  }
  .scroll {
    margin-top: 45px;
  }
  .dec {
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 13px;
    background: #f7f7f7;
    border-top: 1px solid #f7f7f7;
    border-bottom: 1px solid #f7f7f7;
    position: fixed;
    width: 100%;
    height: 45px;
    .paddingLeft {
      padding-left: 17px;
      width: 85px;
    }
    .wages {
      margin-left: 1vw;
      padding-right: 12px;
    }
  }
  .brokerage_price {
    display: flex;
    font-size: 20px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
  }
}
// .header {
//   height: 120px;
//   background: #fd6a5f;
//   text-align: center;
//   color: #fff;
//   .brokerage_title {
//     height: 50px;
//     line-height: 50px;
//   }
// }
.main {
  margin: 1vw 0;
  background: #fff;
}
.list {
  display: flex;
  padding: 8px 17px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f4f4f4;
  margin: 0 0.15rem;
  height: 40px;
  .image {
    width: 32px;
    height: 32px;
    padding: 0 3vw;
  }
  .shop {
    color: #b3b3b3;
    font-size: 12px;
  }
  .list_r {
    
    font-weight: bold;
  }
  // .list_l {
  //   height: 40px;
  //   line-height: 40px;
  // }
}
</style>